// Hermes tenant store — holds the current vendor (tenant) name so the top-bar
// tenant pill (HermesTenantSwitcher, mounted in structure/TheTopMenuBar.vue)
// shows the real vendor on EVERY route, not just the dashboard.
//
// Why a store: the server threads `vendorName` onto the topbar only where the
// build supplies it (reliably on the dashboard, via ShellChromeHook), so
// off-dashboard pages fell back to a generic "Vendor" label. The dashboard also
// learns the name from GET /admin/summary (`vendor_name`). Caching that once in
// a Pinia store — seeded from whichever page has it first, and lazily fetched
// otherwise — makes the pill correct app-wide and survives the topbar
// re-mounting on each server-driven navigation.
//
// Persisted via pinia-plugin-persistedstate (registered in index.js) so the
// name is instantly correct after a hard reload on any page. The fetch itself
// lives in the component (where useApi()'s composables are valid); this store
// stays a plain cache.

import { defineStore } from 'pinia';

export const useTenantStore = defineStore('hermesTenant', {
  state: () => ({
    // Current vendor/tenant display name. Empty until seeded or fetched.
    vendorName: '',
    // Payment mode label. The server sets it on each page; a screen that changes a
    // connection updates it so the bar does not contradict the page.
    paymentMode: '',
  }),

  actions: {
    // Set the vendor name from any source (server-threaded prop or API).
    // No-ops on empty/blank input so a missing value never clobbers a good one.
    setVendorName(name) {
      const next = (name ?? '').toString().trim();
      if (next) {
        this.vendorName = next;
      }
    },
    setPaymentMode(mode) {
      this.paymentMode = mode;
    },
  },

  persist: true,
});

export default useTenantStore;
